import { api_GET } from "../api/_axios.js";

const regional_api =
{
    getAll: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`regional`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getAllWithoutGeoJson: function(concessionariaId = ''){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`regional/getAllWithoutGeoJson/${concessionariaId}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default regional_api
